import { type UseQueryResult, useQuery } from 'react-query';
import { RsuAwardService } from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetRSUFileNameList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const { createdFromDate: fromDate, createdToDate: toDate } = tableInfo;
  const RSUFileNameList = useQuery(
    ['getRSUFileNameList', fromDate, toDate],
    async () => {
      return await handleRequest(
        RsuAwardService.getApiAwardApiAppRSUAwardRSUFileNameList(fromDate, toDate)
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item ?? '',
            value: item ?? '',
          };
        });
      },
    }
  );

  return RSUFileNameList;
};

export default useGetRSUFileNameList;
